var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignageLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M486.886 103H25.1153C11.2446 103 0 114.244 0 128.115V383.104C0 396.974 11.2446 408.219 25.1153 408.219H486.886C500.756 408.219 512 396.974 512 383.104V128.115C512 114.244 500.756 103 486.886 103Z",
    fill: "#F4D25E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M455.911 137.873H56.0936C44.7962 137.873 35.6382 147.031 35.6382 158.329V352.89C35.6382 364.187 44.7962 373.345 56.0936 373.345H455.911C467.208 373.345 476.366 364.187 476.366 352.89V158.329C476.366 147.031 467.208 137.873 455.911 137.873Z",
    fill: "#F1583C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M425.07 173.363H86.9107C78.268 173.363 71.2617 180.37 71.2617 189.013V322.237C71.2617 330.879 78.268 337.885 86.9107 337.885H425.07C433.712 337.885 440.719 330.879 440.719 322.237V189.013C440.719 180.37 433.712 173.363 425.07 173.363Z",
    fill: "#F4D25E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M395.108 208.997H116.909C111.051 208.997 106.301 213.747 106.301 219.607V291.64C106.301 297.499 111.051 302.249 116.909 302.249H395.108C400.967 302.249 405.717 297.499 405.717 291.64V219.607C405.717 213.747 400.967 208.997 395.108 208.997Z",
    fill: "#F1583C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M263.516 264.652L281.304 337.916H230.693L248.482 264.652C253.472 265.277 258.525 265.277 263.516 264.652Z",
    fill: "#F4D25E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256.022 259.114C262.449 259.114 267.657 253.905 267.657 247.48C267.657 241.054 262.449 235.846 256.022 235.846C249.596 235.846 244.388 241.054 244.388 247.48C244.388 253.905 249.596 259.114 256.022 259.114Z",
    fill: "#F4D25E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignageLogo);
export default __webpack_public_path__ + "static/media/signage_logo.518323f49a49ad0e93b29bfb063acbbc.svg";
export { ForwardRef as ReactComponent };